<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>Deactivate Organization</h2>

<mat-dialog-content class="dialog-content">
  <p class="mt-1 mb-2">
    Are you sure you want to deactivate <strong>{{ data?.orgName || 'GeneralTire' }}</strong>?
  </p>

  <!-- Reason Dropdown -->
  <mat-form-field appearance="fill" class="reason-field mb-4">
    <mat-label>Select a reason</mat-label>
    <mat-select
      [(ngModel)]="selectedReason"
      name="deactivationReason"
      panelClass="reason-select-panel"
      required
    >
      <mat-option *ngFor="let reason of deactivationReasons" [value]="reason">
        {{ reason }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="!selectedReason">Reason is required</mat-error>
  </mat-form-field>

  <!-- Comments Textarea -->
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>
      Comments
      <span *ngIf="selectedReason === 'Other'" class="required-asterisk">(required) <span class="text-red-500"></span></span>
      <span *ngIf="selectedReason !== 'Other'" class="text-muted">(optional)</span>
    </mat-label>
    <textarea
      matInput
      name="comments"
      [(ngModel)]="comments"
      rows="3"
      [required]="selectedReason === 'Other'"
    ></textarea>
    <mat-error *ngIf="selectedReason === 'Other' && showCommentError">
      Comments are required when selecting "Other".
    </mat-error>
  </mat-form-field>
  
</mat-dialog-content>

<mat-dialog-actions align="end" class="pt-4">
  <button mat-button (click)="cancel()">Cancel</button>
  <button 
  mat-raised-button 
  color="warn" 
  (click)="confirmDeactivation()" 
  [disabled]="isDeactivating"
>
  {{ isDeactivating ? 'Deactivating...' : 'Deactivate' }}
</button>
</mat-dialog-actions>
</div>